<!-- <div class="container-fluid mt-4 " style="min-height: calc(100vh - 108px)"> -->

  <div class="card">
    <div class="card-header">
      <h5 class="card-title"> {{ 'electricityRate' | translate }} </h5>
      <h6 class="card-subtitle text-muted">{{ 'configElectricityRate' | translate }}</h6>
    </div>
    <div class="card-body">
      <form>

        <div class="d-flex flex-column align-items-center mx-auto mt-3 col-12 col-md-6 col-lg-4">
          <label class="form-label fw-semibold mb-2 text-center w-100 text-primary" for="tariffCurrency">
            <i class="fas fa-coins text-secondary"></i>
            <span class="ms-2">{{ 'currency' | translate }}</span>
          </label>
          <div class="input-group input-group-sm w-100">
            <select
              id="tariffCurrency"
              class="form-select"
              [(ngModel)]="coin"
              name="coin">
              <option *ngFor="let c of currencies" [ngValue]="c.code">{{ c.code }}</option>
            </select>
            <span class="input-group-text">{{ symbolCoin }}</span>
          </div>
        </div>



        <div class="d-flex  m-auto button-group-container justify-content-center mt-5">
          <div class="col-4 text-center p-1 button-group" [ngClass]="{'bg-primary text-white' : type == 'fixed' }"
            (click)="type='fixed'">
            {{ 'fixed' | translate }}
          </div>
          <div class="col-4 text-center p-1 button-group" [ngClass]="{'bg-primary text-white' : type == 'periods' }"
            (click)="type='periods'">
            {{ 'periods' | translate }}
          </div>
          <div class="col-4 text-center p-1 button-group" [ngClass]="{'bg-primary text-white' : type == 'custom' }"
            (click)="type='custom'">
            {{ 'customize' | translate }}
          </div>
        </div>
        <p *ngIf="type == 'fixed'"> {{ 'fixedRateDescription' | translate }} </p>
        <p *ngIf="type == 'periods'"> {{ 'periodsRateDescription' | translate }} </p>
        <p *ngIf="type == 'custom'"> {{ 'customRateDescription' | translate }} </p>


        <!-- Formulario de Tarifa Fija  -->
        <div class="tariff-section" *ngIf="type == 'fixed'">
          <div class="form-card">
            <div class="fixed-rate-header">
              <h6 class="fixed-rate-title">
                <span class="euro-icon">{{symbolCoin}}</span>
                {{ 'fixedRate' | translate }}
              </h6>
              <small class="fixed-rate-description">{{ 'fixedRateDescription' | translate }}</small>
            </div>
            <div class="form-field">
              <label class="field-label">
                {{ 'pricePerKwh' | translate }}
              </label>
              <div class="input-group-modern">
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  class="form-control-modern"
                  [(ngModel)]="tFija.price"
                  placeholder="0.00">
                <span class="input-suffix">{{symbolCoin}}/kWh</span>
              </div>
              <small class="field-hint">{{ 'fixedRateHint' | translate }}</small>
            </div>
          </div>
        </div>


        <!-- Formulario de Tarifa por Periodos  -->
        <div class="tariff-section" *ngIf="type == 'periods'">
          <div class="periods-selector pt-0">
            <div class="selector-label">
              ⚡ {{ 'numberOfPeriods' | translate }}
            </div>
            <div class="button-group-container">
              <div class="button-group" [ngClass]="{'bg-primary text-white' : periods == 2 }"
                (click)="setTwoPeriods()">
                2 {{ 'periods' | translate }}
              </div>
              <div class="button-group" [ngClass]="{'bg-primary text-white' : periods == 3 }"
                (click)="setThreePeriods()">
                3 {{ 'periods' | translate }}
              </div>
            </div>
          </div>

          <div class="periods-container mt-4"
               [class.two-items]="periods === 2"
               [class.multiple-items]="periods >= 3">
            <!-- Periodo Punta -->
            <div class="period-card punta-card">
              <div class="period-header">
                <h6 class="period-title">
                  <span class="period-icon euro-icon">{{symbolCoin}}{{symbolCoin}}{{symbolCoin}}</span>
                  {{ 'peakPeriod' | translate }}
                </h6>
                <small class="period-description">{{ 'peakPeriodDescription' | translate }}</small>
              </div>
              <div class="period-form">
                <div class="form-row">
                  <!-- <div class="form-field">
                    <label class="field-label">Potencia contratada</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="100"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="tPeriods[0].power"
                        placeholder="0">
                      <span class="input-suffix">W</span>
                    </div>
                  </div> -->
                  <div class="form-field">
                    <label class="field-label">{{ 'energyPrice' | translate }}</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="puntaPrice"
                        name="puntaPrice"
                        placeholder="0.00">
                      <span class="input-suffix">{{symbolCoin}}/kWh</span>
                    </div>
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'configuredSchedules' | translate }}</label>
                  <div class="time-schedule-list">
                    <div class="schedule-item" *ngFor="let slot of tPeriods[0].schedule; let i = index">
                      <div class="schedule-info">
                        <span class="schedule-time">{{formatTimeForDisplay(slot.init_time)}} - {{formatTimeForDisplay(slot.end_time)}}</span>
                        <span class="schedule-days">{{getScheduleDaysFromWeekday(slot.weekday)}}</span>
                      </div>
                      <button
                        type="button"
                        class="btn-edit-schedule"
                        (click)="editTimeSlot(0, i)">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        type="button"
                        class="btn-remove-schedule"
                        [class.disabled]="tPeriods[0].schedule.length <= 1"
                        [disabled]="tPeriods[0].schedule.length <= 1"
                        (click)="removeTimeSlot(0, i)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn-add-schedule"
                      (click)="addNewTimeSlot(0)">
                      <i class="fas fa-plus"></i>
                      {{ 'addSchedule' | translate }}
                    </button>
                  </div>
                  <small class="field-hint">{{ 'defineTimeSlots' | translate }}</small>
                </div>
              </div>
            </div>

            <!-- Periodo Llano (solo si periods == 3) -->
            <div class="period-card llano-card" *ngIf="periods == 3">
              <div class="period-header">
                <h6 class="period-title">
                  <span class="period-icon euro-icon">{{symbolCoin}}{{symbolCoin}}</span>
                  {{ 'flatPeriod' | translate }}
                </h6>
                <small class="period-description">{{ 'flatPeriodDescription' | translate }}</small>
              </div>
              <div class="period-form">
                <div class="form-row">
                  <!-- <div class="form-field">
                    <label class="field-label">Potencia contratada</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="100"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="tPeriods[1].power"
                        placeholder="0">
                      <span class="input-suffix">W</span>
                    </div>
                  </div> -->
                  <div class="form-field">
                    <label class="field-label">{{ 'energyPrice' | translate }}</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="llanoPrice"
                        name="llanoPrice"
                        placeholder="0.00">

                      <span class="input-suffix">{{symbolCoin}}/kWh</span>
                    </div>
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'configuredSchedules' | translate }}</label>
                  <div class="time-schedule-list">
                    <div class="schedule-item" *ngFor="let slot of tPeriods[1].schedule; let i = index">
                      <div class="schedule-info">
                        <span class="schedule-time">{{formatTimeForDisplay(slot.init_time)}} - {{formatTimeForDisplay(slot.end_time)}}</span>
                        <span class="schedule-days">{{getScheduleDaysFromWeekday(slot.weekday)}}</span>
                      </div>
                      <button
                        type="button"
                        class="btn-edit-schedule"
                        (click)="editTimeSlot(1, i)">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        type="button"
                        class="btn-remove-schedule"
                        [class.disabled]="tPeriods[1].schedule.length <= 1"
                        [disabled]="tPeriods[1].schedule.length <= 1"
                        (click)="removeTimeSlot(1, i)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn-add-schedule"
                      (click)="addNewTimeSlot(1)">
                      <i class="fas fa-plus"></i>
                      {{ 'addSchedule' | translate }}
                    </button>
                  </div>
                  <small class="field-hint">{{ 'defineTimeSlots' | translate }}</small>
                </div>
              </div>
            </div>

            <!-- Periodo Valle -->
            <div class="period-card valle-card">
              <div class="period-header">
                <h6 class="period-title">
                  <span class="period-icon euro-icon">{{symbolCoin}}</span>
                  {{ 'valleyPeriod' | translate }}
                </h6>
                <small class="period-description">{{ 'valleyPeriodDescription' | translate }}</small>
              </div>
              <div class="period-form">
                <div class="form-row">
                  <!-- <div class="form-field">
                    <label class="field-label">Potencia contratada</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="100"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="tPeriods[getValleIndex()].power"
                        placeholder="0">
                      <span class="input-suffix">W</span>
                    </div>
                  </div> -->
                  <div class="form-field">
                    <label class="field-label">{{ 'energyPrice' | translate }}</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="vallePrice"
                        name="vallePrice"
                        placeholder="0.00">
                      <span class="input-suffix">{{symbolCoin}}/kWh</span>
                    </div>
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'configuredSchedules' | translate }}</label>
                  <div class="time-schedule-list">
                    <div class="schedule-item" *ngFor="let slot of tPeriods[getValleIndex()].schedule; let i = index">
                      <div class="schedule-info">
                        <span class="schedule-time">{{formatTimeForDisplay(slot.init_time)}} - {{formatTimeForDisplay(slot.end_time)}}</span>
                        <span class="schedule-days">{{getScheduleDaysFromWeekday(slot.weekday)}}</span>
                      </div>
                      <button
                        type="button"
                        class="btn-edit-schedule"
                        (click)="editTimeSlot(getValleIndex(), i)">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        type="button"
                        class="btn-remove-schedule"
                        [class.disabled]="tPeriods[getValleIndex()].schedule.length <= 1"
                        [disabled]="tPeriods[getValleIndex()].schedule.length <= 1"
                        (click)="removeTimeSlot(getValleIndex(), i)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn-add-schedule"
                      (click)="addNewTimeSlot(getValleIndex())">
                      <i class="fas fa-plus"></i>
                      {{ 'addSchedule' | translate }}
                    </button>
                  </div>
                  <small class="field-hint">{{ 'defineTimeSlots' | translate }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Formulario de Tarifa Personalizada  -->
        <div class="tariff-section" *ngIf="type == 'custom'">
          <div class="custom-header">
            <h6 class="custom-title">
              <i class="fas fa-cog custom-icon"></i>
            {{ 'customConfiguration' | translate }}
            </h6>
            <p class="custom-description">{{ 'customConfigurationDescription' | translate }}</p>
          </div>

          <div class="custom-periods-container"
               [class.single-item]="tcustom?.length === 1"
               [class.two-items]="tcustom?.length === 2"
               [class.multiple-items]="tcustom?.length >= 3">
            <div class="custom-period-card" *ngFor="let period of tcustom; let i = index">
              <div class="custom-period-header">
                <h6 class="custom-period-title">
                  <span class="period-number">{{i + 1}}</span>
                  {{ 'period' | translate }} {{i + 1}}
                </h6>
                <button
                  type="button"
                  class="btn-remove-period"
                  *ngIf="tcustom.length > 1"
                  (click)="removePeriod(i)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>

              <div class="custom-period-form">
                <div class="form-row">
                  <!-- <div class="form-field">
                    <label class="field-label">Nombre del periodo</label>
                    <div class="input-group-modern">
                      <input
                        type="text"
                        class="form-control-modern"
                        [(ngModel)]="period.name"
                        placeholder="Ej: Madrugada">
                      <span class="input-suffix">
                        <i class="fas fa-tag"></i>
                      </span>
                    </div>
                  </div> -->
                  <!-- <div class="form-field">
                    <label class="field-label">Potencia contratada</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="100"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="period.power"
                        placeholder="0">
                      <span class="input-suffix">W</span>
                    </div>
                  </div> -->
                  <div class="form-field">
                    <label class="field-label">{{ 'energyPrice' | translate }}</label>
                    <div class="input-group-modern">
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control-modern"
                        [(ngModel)]="period.price"
                        placeholder="0.00">
                      <span class="input-suffix">{{symbolCoin}}/kWh</span>
                    </div>
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'configuredSchedules' | translate }}</label>
                  <div class="time-schedule-list">
                    <div class="schedule-item" *ngFor="let slot of period.schedule; let j = index">
                      <div class="schedule-info">
                        <span class="schedule-time">{{formatTimeForDisplay(slot.init_time)}} - {{formatTimeForDisplay(slot.end_time)}}</span>
                        <span class="schedule-days">{{getScheduleDaysFromWeekday(slot.weekday)}}</span>
                      </div>
                      <button
                        type="button"
                        class="btn-edit-schedule"
                        (click)="editCustomTimeSlot(i, j)">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        type="button"
                        class="btn-remove-schedule"
                        [class.disabled]="period.schedule.length <= 1"
                        [disabled]="period.schedule.length <= 1"
                        (click)="removeCustomTimeSlot(i, j)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn-add-schedule"
                      (click)="addNewCustomTimeSlot(i)">
                      <i class="fas fa-plus"></i>
                      {{ 'addSchedule' | translate }}
                    </button>
                  </div>
                  <small class="field-hint">{{ 'defineTimeSlots' | translate }}</small>
                </div>
              </div>
            </div>
          </div>

          <div class="add-period-container">
            <button
              type="button"
              class="btn-add-period"
              (click)="addPeriod()">
              <i class="fas fa-plus"></i>
              {{ 'addPeriod' | translate }}
            </button>
          </div>
        </div>


        <div class="form-group row mt-5">
          <div class="col-sm-8 ms-sm-auto">
            <button type="submit" class="btn btn-primary " (click)="save()">{{"save" | translate}}</button>
            <button type="button" class="btn btn-light ms-2" (click)="cancel()">{{"restore" | translate}}</button>
          </div>
        </div>
      </form>
      <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
        <div class="alert-message">
          {{ error }}
        </div>
      </div>
      <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
        <div class="alert-message ">
          {{"updatedSuccesfully" | translate}}
        </div>
      </div>
    </div>
  </div>
<!-- </div> -->

<!-- Modal para configurar horarios -->
<div class="modal fade" id="timeSlotModal" tabindex="-1" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" [ngClass]="getPeriodModalClass()">
        <h5 class="modal-title">
          <i class="fas fa-clock me-2"></i>
          {{editingSlot.isNew ? 'Añadir' : 'Editar'}} {{ 'schedule' | translate }}
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form">
          <!-- Configuración de horario -->
          <div class="form-field">
            <label class="field-label">{{ 'schedule' | translate }}</label>
            <div class="time-config">
              <div class="time-input-group">
                <label class="time-label">{{ 'historicsStartTime' | translate }}</label>
                <input
                  type="time"
                  class="form-control-time"
                  [(ngModel)]="editingSlot.start"
                  placeholder="00:00">
              </div>
              <div class="time-separator-modal">{{ 'until' | translate }}</div>
              <div class="time-input-group">
                <label class="time-label">{{ 'historicsEndTime' | translate }}</label>
                <input
                  type="time"
                  class="form-control-time"
                  [(ngModel)]="editingSlot.end"
                  placeholder="23:59">
              </div>
            </div>
          </div>

          <!-- Selector de días de la semana -->
          <div class="form-field">
            <label class="field-label">{{ 'weekDays' | translate }}</label>
            <div class="days-selector-modal">
              <div class="day-button-modal"
                   [class.active]="isModalDaySelected('L')"
                   (click)="toggleModalDay('L')">
                <span class="day-letter">L</span>
                <span class="day-name">{{ 'monday' | translate }}</span>
              </div>
              <div class="day-button-modal"
                   [class.active]="isModalDaySelected('M')"
                   (click)="toggleModalDay('M')">
                <span class="day-letter">M</span>
                <span class="day-name">{{ 'tuesday' | translate }}</span>
              </div>
              <div class="day-button-modal"
                   [class.active]="isModalDaySelected('X')"
                   (click)="toggleModalDay('X')">
                <span class="day-letter">X</span>
                <span class="day-name">{{ 'wednesday' | translate }}</span>
              </div>
              <div class="day-button-modal"
                   [class.active]="isModalDaySelected('J')"
                   (click)="toggleModalDay('J')">
                <span class="day-letter">J</span>
                <span class="day-name">{{ 'thursday' | translate }}</span>
              </div>
              <div class="day-button-modal"
                   [class.active]="isModalDaySelected('V')"
                   (click)="toggleModalDay('V')">
                <span class="day-letter">V</span>
                <span class="day-name">{{ 'friday' | translate }}</span>
              </div>
              <div class="day-button-modal weekend"
                   [class.active]="isModalDaySelected('S')"
                   (click)="toggleModalDay('S')">
                <span class="day-letter">S</span>
                <span class="day-name">{{ 'saturday' | translate }}</span>
              </div>
              <div class="day-button-modal weekend"
                   [class.active]="isModalDaySelected('D')"
                   (click)="toggleModalDay('D')">
                <span class="day-letter">D</span>
                <span class="day-name">{{ 'sunday' | translate }}</span>
              </div>
            </div>
            <small class="field-hint">{{ 'selectDaysHint' | translate }}</small>
          </div>

          <!-- Atajos rápidos -->
          <div class="form-field">
            <label class="field-label">{{ 'quickShortcuts' | translate }}</label>
            <div class="quick-presets">
              <button type="button" class="btn-preset" (click)="setQuickPreset('weekdays')">
                <i class="fas fa-briefcase"></i>
                {{ 'workdays' | translate }}
              </button>
              <button type="button" class="btn-preset" (click)="setQuickPreset('weekend')">
                <i class="fas fa-bed"></i>
                {{ 'weekend' | translate }}
              </button>
              <button type="button" class="btn-preset" (click)="setQuickPreset('all')">
                <i class="fas fa-calendar"></i>
                {{ 'allDays' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          {{ 'cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="saveTimeSlot()">
          {{editingSlot.isNew ? 'Añadir' : 'Guardar'}} {{ 'schedule' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del modal -->
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal" (click)="closeModal()"></div>

